module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3jkYV"))).then(() => parcelRequire('d0iPb'));